import { defineStore } from 'pinia';
import { mergeStores } from '@/store/helpers';
import mdHouseConfig from '../../md-house/_store/config';
import mdSearchConfig from './config';
import mdSearchBarConfig from '../../md-search-bar/_store/config';
import mdSearchResultConfig from '@/components/search-result/_store/config';
import mdSnapshotSearchConfig from '../../md-snapshot-search/_store/config';

export default (storeName, pinia) => defineStore(storeName, mergeStores(mdHouseConfig, mdSearchConfig, mdSearchBarConfig(pinia), mdSnapshotSearchConfig, mdSearchResultConfig));
